// Всплывающее сообщение внизу экрана (3,5 с)
import { createStore, useStore } from '../lib/store';

const toastStore = createStore({ text: '', visible: false, n: 0 });
let timer: ReturnType<typeof setTimeout> | undefined;

export function toast(text: string): void {
  toastStore.set((s) => ({ text, visible: true, n: s.n + 1 }));
  clearTimeout(timer);
  timer = setTimeout(() => toastStore.set({ visible: false }), 3500);
}

export function ToastHost() {
  const { text, visible } = useStore(toastStore);
  return <div id="toast" className="toast" hidden={!visible}>{text}</div>;
}
